var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.5C1 5.5 3.49963 0.5 7.87472 0.5C12.2498 0.5 14.7494 5.5 14.7494 5.5C14.7494 5.5 12.2498 10.5 7.87472 10.5C3.49963 10.5 1 5.5 1 5.5Z",
    stroke: "#707070",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7514 5.49997C9.7514 5.87072 9.64147 6.23315 9.4355 6.54143C9.22954 6.84971 8.93679 7.09 8.59427 7.23191C8.25175 7.37383 7.87485 7.411 7.51121 7.33872C7.14757 7.26644 6.81352 7.08797 6.55131 6.82586C6.2891 6.56375 6.11049 6.22977 6.03807 5.86616C5.96565 5.50255 6.00267 5.12563 6.14445 4.78306C6.28622 4.44048 6.5264 4.14764 6.8346 3.94155C7.14279 3.73547 7.50518 3.62539 7.87593 3.62524C8.12219 3.62515 8.36605 3.67357 8.59359 3.76774C8.82112 3.86191 9.02788 3.99998 9.20204 4.17407C9.3762 4.34817 9.51436 4.55487 9.60862 4.78237C9.70288 5.00987 9.7514 5.25371 9.7514 5.49997Z",
    stroke: "#707070",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.c1850fc8a49652e738f586051cc1feff.svg";
export { ForwardRef as ReactComponent };